import { useMediaQuery, useTheme } from "@mui/material";

export default function useHeaderHeight() {
  const theme = useTheme();
  const mdUp = useMediaQuery(theme.breakpoints.up("md"));
  const xsUp = useMediaQuery(theme.breakpoints.up("sm"));

  return mdUp ? 0 : xsUp ? 64 : 56;
}
